// extracted by mini-css-extract-plugin
export var dropdownContainer = "bn_d4";
export var dropdownWrapper = "bn_d5";
export var errorInput = "bn_dS";
export var errorLabel = "bn_dR";
export var textlabel = "bn_dM";